import React, { useCallback, useEffect } from 'react';
import { TableCell, TableRow } from '@mui/material';
import { setHighlighting, removeHighlighting } from '../../../reducer/tableUIReducer'
import { useSelector, useDispatch } from 'react-redux'
import { useState } from 'react';
import Resizer from './Resizer';
import rafSchedule from 'raf-schd';

export const HighlightedTableCell = React.forwardRef(
  ({
    isId,
    isMark,
    isTitle,
    isHead,
    isEmptyCell,
    ancestorId,
    cellClassName,
    children,
    classes,
    nodeId,
    resizable,
    rstChainId,
    tableId,
  }, refCallback) => {
    let tableCellRef;
    let columnKey;

    if (!isId) isId = false;
    if (!isTitle) isTitle = false;
    if (!isHead) isHead = false;
    if (!isEmptyCell) isEmptyCell = false;
    const queryByAncestor = ancestorId === tableId;

    const columnPrefix = queryByAncestor ? "a" + ancestorId : "t" + tableId;
    if (isId) columnKey =         columnPrefix + ".id";
    else if (isMark) columnKey =  columnPrefix + ".mark";
    else if (isTitle) columnKey = columnPrefix + ".title";
    else columnKey =              columnPrefix + "." + rstChainId;
    
    let [width, setWidth] = useState(0);

    const highlightVertical = useSelector(
      state => state.tableUI.tableId === tableId
        && rstChainId
        && state.tableUI.highlightedRstChainId === rstChainId
    );

    const highlightHorizontal = useSelector(
      state => state.tableUI.tableId === tableId
        && nodeId
        && state.tableUI.highlightedNodeId === nodeId
    );

    const dispatch = useDispatch();

    const highlight = useCallback(
      () => dispatch(setHighlighting({ nodeId, rstChainId, tableId})),
      [dispatch, nodeId, rstChainId, tableId]
    );
    const stopHighlight = useCallback(
      () => dispatch(removeHighlighting({ nodeId, rstChainId, tableId})),
      [dispatch, nodeId, rstChainId, tableId]
    );

    const onChangeWidth = useCallback(rafSchedule(
      shift => {
        let newWidth = parseInt(width, 10) - shift;
        newWidth = newWidth > 40 ? Math.round(newWidth) : 40;
        setWidth(newWidth);
        localStorage.setItem(columnKey, newWidth);
      },
      [width]
    ));

    const onChangeWidthByClick = useCallback(
      shift => {
        let newWidth = Math.round(parseInt(width, 10) + parseInt(shift, 10));
        setWidth(newWidth);
        localStorage.setItem(columnKey, newWidth);
      },
      [width]
    );

    const setRef = useCallback(
      node => {
        tableCellRef = node;
        refCallback && refCallback(node);
      }, [refCallback]
    );

    useEffect(() => {
      let w = 0;
      if (isHead && resizable === true) {
        if (localStorage.getItem(columnKey)) w = Math.round(localStorage.getItem(columnKey));
        else if (tableCellRef && tableCellRef.offsetWidth > 600) w = 600;
        else if (!localStorage.getItem(columnKey) && tableCellRef && tableCellRef.offsetWidth > 0) w = Math.round(tableCellRef.offsetWidth + 15);
        else if (w < 10) w = 30;
        setWidth(w);
      } else if (isHead && isId && resizable === false){
        if (tableCellRef && tableCellRef.offsetWidth > 0) w = Math.round(tableCellRef.offsetWidth);
        else if (w < 10) w = 30;
        setWidth(w);
      }
    }, []);

    const regularSx = {
      fontSize: 12,
      paddingRight: 0,
      paddingLeft: 0,
      minHeight: '25px',
      lineHeight: 'normal',
      verticalAlign: 'middle',
      boxSizing: 'border-box',
      backfaceVisibility: 'hidden',
      MozOsxFontSmoothing: 'auto',
      textRendering: 'optimizeLegibility',
      WebkitFontSmoothing: 'subpixel-antialiased',
    };

    const headSx = {
      boxShadow: `
      inset 1px 0 0 rgb(255, 255, 255),
      inset -1px 0 0 rgb(255, 255, 255),
      inset 0 -1px 0 rgb(255, 255, 255),
      inset 0 0 -1px rgb(255, 255, 255),
    `,
    };

    return (
      <TableCell
        sx={
          isHead ? { ...headSx, ...headSx } : regularSx
        }
        style={{ width: isMark ? '17px' : isEmptyCell ? 'auto' : width + 'px' }}
        ref={setRef}
        className={`${cellClassName} ${
          highlightHorizontal ? classes.highlightedRowCell : highlightVertical && isHead ? classes.highlightHead : ''
          //: highlightVertical && isHead ? classes.highlightHead :
          //highlightVertical ? classes.highlightVertical : ''// highlightHorizontal ? classes.highlightHorisontal : ''
        }`}
        onMouseEnter={highlight}
        onMouseLeave={stopHighlight}
      >
        {children}
        {resizable && <Resizer classes={classes} onChangeWidth={onChangeWidth} onChangeWidthByClick={onChangeWidthByClick} />}
      </TableCell>
    )
  }
);

export const HighlightedTableRow = ({
  rowBorderBold,
  highlightRow,
  rowClassName,
  children,
  classes,
  nodeId,
  tableId,
}) => {

  const highlighted = useSelector(
    state => state.tableUI.tableId === tableId
      && nodeId
      && state.tableUI.highlightedNodeId === nodeId
  );

  return (
    <TableRow
      //sx={{ borderTop: '1px solid white' }}
      key={`table-row-${nodeId}`}
      className={`${rowClassName} ${
        rowBorderBold && highlighted ? classes.highlightHorisontalRowBold
        : rowBorderBold ? classes.borderhBold
        : highlighted ? classes.highlightHorisontalRow : ''
      }`}
      style={{
        minHeight: '25px',
        backgroundColor: highlightRow !== null && (highlightRow ? 'rgb(175 252 79)' : ''),
        transition: highlightRow !== null && (highlightRow ? '' : 'background-color 29s ease-out'),
      }}
    >
      {children}
    </TableRow>
  )
};
